import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Search, X } from "lucide-react";
import { useAppDispatch } from "../../../../Redux/Hooks";
import { SearchData } from "../../../../Redux/ApiCalls/Dashboard/SearchAPI";
import { getAllAlbums } from "../../../../Redux/ApiCalls/Dashboard/AlbumAPI";
import { getAllMembers } from "../../../../Redux/ApiCalls/Dashboard/MembersAPI";
import { usePermissions } from "../../../../hooks/usePermissions";

const SearchBar: React.FC = () => {
  const [inputData, setInputData] = useState("");
  const dispatch = useAppDispatch();
  const { isStudioOwner, hasModule, hasPermission } = usePermissions();

  useEffect(() => {
    const searchTimeout = setTimeout(async () => {
      if (inputData.length >= 2) await SearchData(inputData, true, true);
      if (inputData.length === 0) {
        if (isStudioOwner || hasModule("ALBUMS") || hasPermission("albums.view")) {
          dispatch(getAllAlbums(1));
        }
        if (isStudioOwner || hasModule("MEMBERS") || hasPermission("members.read")) {
          dispatch(getAllMembers());
        }
      }
    }, 1000);

    return () => {
      clearTimeout(searchTimeout);
    };
  }, [inputData, dispatch, isStudioOwner, hasModule, hasPermission]);

  const handleClear = () => {
    setInputData("");
  };

  return (
    <SearchBarContainer>
      <SearchIconWrap>
        <Search size={16} />
      </SearchIconWrap>
      <Input
        type="text"
        placeholder="Search albums, members, and more…"
        value={inputData}
        onChange={(e) => setInputData(e.target.value)}
        aria-label="Search dashboard"
      />
      {inputData.length > 0 && (
        <ClearBtn type="button" onClick={handleClear} aria-label="Clear search">
          <X size={14} />
        </ClearBtn>
      )}
    </SearchBarContainer>
  );
};

export default SearchBar;

const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  max-width: 520px;
  height: 44px;
  padding: 0 14px 0 12px;
  border-radius: 12px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.08);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  &:focus-within {
    background: #fff;
    border-color: rgba(201, 77, 170, 0.35);
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

const SearchIconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c94daa;
  flex-shrink: 0;
`;

const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;

  &::placeholder {
    color: rgba(23, 23, 23, 0.38);
    font-weight: 500;
  }
`;

const ClearBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: rgba(23, 23, 23, 0.06);
  color: rgba(23, 23, 23, 0.55);
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(201, 77, 170, 0.1);
    color: #c94daa;
  }
`;
